<div class="auth-wrapper align-items-stretch aut-bg-img">
  <div class="flex-grow-1">
    <div class="h-100 d-md-flex align-items-center auth-side-img row">
      <div class="col-sm-10 auth-content w-auto">
        <img src="assets/dev_images/auth/PerformoLab-01_No BG.png" style="width: 29%" alt="logo" class="img-fluid" />
        <h1 class="text-white my-4">Change securely!</h1>
        <h4 class="text-white font-weight-normal">
          Change your account password and make yourself more secure.
          <br />
          Do not forget to explore customization options.
        </h4>
      </div>
    </div>

    <div class="auth-side-form">
      <div class="auth-content">
        <form (ngSubmit)="onSubmit()">
          <img src="assets/dev_images/auth/PerformoLab-01_No BG.png" alt="logo" class="img-fluid mb-4 d-block d-xl-none d-lg-none" />

          <h4 class="mb-3 f-w-400">Set your New Password</h4>

          @if (errorMessage()) {
          <div class="alert alert-danger">{{ errorMessage() }}</div>
          }

          <div class="input-group mb-3">
            <span class="input-group-text">
              <i class="feather icon-lock"></i>
            </span>

            <input
              [type]="showPassword ? 'text' : 'password'"
              class="form-control"
              placeholder="New Password"
              [field]="passwordForm.newPassword"
              [class.is-invalid]="submitted() && passwordForm.newPassword().invalid()"
            />

            <span class="input-group-text" (click)="togglePasswordVisibility()">
              <i class="feather" [ngClass]="showPassword ? 'icon-eye-off' : 'icon-eye'"></i>
            </span>
          </div>

          @if (submitted() && passwordForm.newPassword().invalid()) {
          <div class="invalid-feedback d-block mb-2">
            @for (error of passwordForm.newPassword().errors(); track error.kind) {
            <div>{{ error.message }}</div>
            }
          </div>
          }

          <ul class="small mb-3">
            <li [class.text-success]="passwordForm().value().newPassword?.length >= 8">8 characters</li>
            <li [class.text-success]="/[A-Z]/.test(passwordForm().value().newPassword)">Uppercase letter</li>
            <li [class.text-success]="/[a-z]/.test(passwordForm().value().newPassword)">Lowercase letter</li>
            <li [class.text-success]="/[0-9]/.test(passwordForm().value().newPassword)">Number</li>
            <li [class.text-success]="/[^A-Za-z0-9]/.test(passwordForm().value().newPassword)">Special character</li>
          </ul>

          <div class="input-group mb-3">
            <span class="input-group-text">
              <i class="feather icon-lock"></i>
            </span>

            <input
              [type]="showConfirmPassword ? 'text' : 'password'"
              class="form-control"
              placeholder="Confirm Password"
              [field]="passwordForm.confirmPassword"
              [class.is-invalid]="submitted() && passwordForm.confirmPassword().invalid()"
            />

            <span class="input-group-text" (click)="toggleConfirmPasswordVisibility()">
              <i class="feather" [ngClass]="showConfirmPassword ? 'icon-eye-off' : 'icon-eye'"></i>
            </span>
          </div>

          @if (submitted() && passwordForm.confirmPassword().invalid()) {
          <div class="invalid-feedback d-block mb-2">
            @for (error of passwordForm.confirmPassword().errors(); track error.kind) {
            <div>{{ error.message }}</div>
            }
          </div>
          } @if (submitted() && passwordsDoNotMatch) {
          <div class="alert alert-danger">Passwords do not match.</div>
          }

          <div class="d-grid">
            <button type="submit" class="btn btn-primary mb-4" [disabled]="loading()">
              @if (!loading()) { Reset Password } @else {
              <span class="spinner-border spinner-border-sm me-2"></span>
              Updating... }
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
